import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import UsersMenu from '../components/users/UsersMenu.vue';
import UsersList from '../components/users/UsersList.vue';
import CommunitiesList from '../components/users/CommunitiesList.vue';
import OrganizationsList from '../components/users/OrganizationsList.vue';

import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'UsersView',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(UsersMenu),
    (_unref(route).path === '/users')
      ? (_openBlock(), _createBlock(UsersList, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(route).path === '/users/communities')
      ? (_openBlock(), _createBlock(CommunitiesList, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(route).path === '/users/organizations')
      ? (_openBlock(), _createBlock(OrganizationsList, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})